var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRootControlDoubleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 18.9728C30 18.9728 29.2152 18.9694 28 18.8659C23.853 18.5125 14.6941 16.9919 14.613 10.4539C14.5317 3.9028 23.8163 2.42828 28 2.0964C29.2152 2 30 2 30 2V18.9728ZM28 16.8582C27.9353 16.8524 27.8694 16.8462 27.8023 16.8397C26.4382 16.7083 24.6501 16.4516 22.8849 15.9575C21.0959 15.4568 19.4771 14.7522 18.3347 13.8091C17.2486 12.9125 16.6304 11.8446 16.6128 10.4291C16.5955 9.03053 17.184 7.98719 18.2475 7.10776C19.3735 6.17662 20.9915 5.47957 22.7953 4.98575C24.5732 4.49899 26.381 4.24963 27.7624 4.12385C27.8432 4.11649 27.9225 4.10957 28 4.10305V16.8582Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1315 10.4253C24.1353 13.8134 25.7488 17.3113 29.09 18.5776L29.4444 17.6425C26.6192 16.5718 25.135 13.553 25.1315 10.4242C25.128 7.29593 26.6049 4.27791 29.4438 3.2066L29.0907 2.271C25.7339 3.53775 24.1277 7.03681 24.1315 10.4253Z",
    fill: "#647B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13.046C2 13.046 2.78491 13.0494 4 13.153C8.14351 13.5063 17.2892 15.0258 17.3702 21.5556C17.4514 28.0984 8.18015 29.5719 4 29.9038C2.78492 30.0002 2 30.0002 2 30.0002L2 13.046ZM4 15.1607C4.06389 15.1665 4.12893 15.1725 4.19507 15.1789C5.55758 15.3102 7.34365 15.5666 9.10677 16.0601C10.8937 16.5602 12.5104 17.264 13.6512 18.2057C14.7357 19.1011 15.3528 20.1672 15.3704 21.5804C15.3877 22.9766 14.8002 24.0183 13.7383 24.8964C12.6138 25.8262 10.9979 26.5224 9.19627 27.0157C7.42042 27.5018 5.61474 27.7509 4.23497 27.8765C4.15504 27.8838 4.07668 27.8907 4 27.8971L4 15.1607Z",
    fill: "#647B8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86266 21.5841C7.85888 18.1996 6.24703 14.7053 2.90924 13.4402L2.55483 14.3753C5.37662 15.4448 6.85917 18.46 6.86266 21.5852C6.86615 24.71 5.39089 27.7244 2.55541 28.7945L2.90848 29.7301C6.26186 28.4646 7.86644 24.9691 7.86266 21.5841Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootControlDoubleLeft);
export default __webpack_public_path__ + "static/media/root-control-double-left.3c801acb.svg";
export { ForwardRef as ReactComponent };